module.exports = __webpack_public_path__ + "static/img/S108_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/S108_1.png
// module id = H25i
// module chunks = 0